import { render, staticRenderFns } from "./dyh-basetable.vue?vue&type=template&id=061c7698&"
import script from "./dyh-basetable.vue?vue&type=script&lang=js&"
export * from "./dyh-basetable.vue?vue&type=script&lang=js&"
import style0 from "./dyh-basetable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports